import {
  DrOrderHistoryStatus,
  DrOrderStatus,
  OrderHistoryStatus,
  OrderStatus,
  SellBuyType,
  StopOrderStatus,
} from 'constants/enum';

export const sellBuyDropdown = [
  { title: 'All', value: 'All' },
  { title: 'Buy', value: SellBuyType.BUY },
  { title: 'Sell', value: SellBuyType.SELL },
];

export const pageSizeDropdown = [
  { title: '10', value: '10' },
  { title: '20', value: '20' },
  { title: '50', value: '50' },
  { title: '100', value: '100' },
];

export const orderStatusDropdown = () =>
  Object.keys(OrderStatus).map((value) => ({
    title: value,
    value: OrderStatus[value],
  }));
export const orderHistoryStatusDropdown = () =>
  Object.keys(OrderHistoryStatus).map((value) => ({
    title: value,
    value: OrderHistoryStatus[value],
  }));

export const derivativesOrderStatusDropdown = () =>
  Object.keys(DrOrderStatus).map((value) => ({
    title: value,
    value: DrOrderStatus[value],
  }));
export const derivativesOrderHistoryStatusDropdown = () =>
  Object.keys(DrOrderHistoryStatus).map((value) => ({
    title: value,
    value: DrOrderHistoryStatus[value],
  }));

export const stopOrderStatusDropdown = [
  { title: 'All', value: 'All' },
  ...Object.keys(StopOrderStatus).map((value) => ({
    title:
      value === StopOrderStatus.PENDING ? 'STOP_ORDER_STATUS_PENDING' : value,
    value: StopOrderStatus[value],
  })),
];



// WEBPACK FOOTER //
// ./src/components/areas/Account/OrderHistory/enum.ts